import { Button, ButtonSize, ButtonStyle } from '@atlas/components';
import cx from 'classnames';
import type { FC } from 'react';
import { useLocation } from 'wouter';

import Icon from 'components/Icon/Icon';
import { Translation } from 'utils/translations';

import styles from './PixForm.module.scss';

export type PixWithdrawalResultProps = {
  type: 'success' | 'error';
  image: string | undefined;
  paymentName: string;
  onNavigateToTransactionHistory?: () => void;
};

const PixWithdrawalResult: FC<PixWithdrawalResultProps> = ({
  image,
  type,
  paymentName,
  onNavigateToTransactionHistory,
}) => {
  const [, navigate] = useLocation();

  return (
    <div className={styles.result}>
      {image && (
        <div className={styles.image}>
          <img src={image} alt={paymentName} />
        </div>
      )}
      <h3 className={cx(styles.title, { [styles.error]: type === 'error' })}>
        <Translation
          message={
            type === 'success'
              ? 'withdrawal_result_success'
              : 'withdrawal_result_error'
          }
        />
      </h3>
      <Icon
        className={type === 'success' ? styles.success : styles.error}
        name={
          type === 'success' ? 'success-payment.bold' : 'error-payment.bold'
        }
        width={40}
        height={40}
      />
      <p className={styles.description}>
        <Translation message="withdrawal_result_text" />
      </p>
      <Button
        size={ButtonSize.big}
        type="button"
        style={ButtonStyle.outline}
        onClick={() => {
          navigate('/account/transactions');
          onNavigateToTransactionHistory?.();
        }}
        data-testid="transaction-history-in-popup"
        className={styles.button}
      >
        <Translation message="transaction_history" />
      </Button>
    </div>
  );
};

export default PixWithdrawalResult;
